import { render, staticRenderFns } from "./DiagnosticImportPage.vue?vue&type=template&id=807e2f92&"
import script from "./DiagnosticImportPage.vue?vue&type=script&lang=js&"
export * from "./DiagnosticImportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports